
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Msg,
Divider,
XButton
},
methods: {

},
data () {
return {
title: '提示',
description: '只能在手机微信或手机支付宝打开哦',
icon: 'warn'
}
}
}



// WEBPACK FOOTER //
// ./src/components/JustWeAli.vue